import { cn } from '@/lib/utils'

/** The mark's three bars (assets/mark.svg), each with when it starts speaking, in ms. */
const BARS = [
  { x: 3.5, y: 16, height: 16, delay: 0 },
  { x: 10.5, y: 10, height: 28, delay: 90 },
  { x: 17.5, y: 18, height: 12, delay: 180 },
]
const ROW_AT = 750

/**
 * The RowCall mark while something on a page loads (DESIGN.md): it plays the logo's opening once, the bars speak and
 * settle and the row is drawn (BRAND.md → Motion: no loop, no pulse), then holds. Still for people who ask for less
 * motion. Drawn inline (not the svg file) so each bar can move; the colours are the theme's.
 */
export const LogoLoader = ({ className }: { className?: string }) => (
  <svg viewBox="0 0 48 48" aria-hidden="true" className={cn('size-12 text-primary', className)}>
    {BARS.map((bar) => (
      <rect
        key={bar.x}
        x={bar.x}
        y={bar.y}
        width="5"
        height={bar.height}
        rx="2.5"
        fill="currentColor"
        className="origin-center transform-fill motion-safe:animate-speak"
        // The bar's turn in the opening: a value, not a style, so it stays here with the bar.
        style={{ animationDelay: `${bar.delay}ms` }}
      />
    ))}
    <line
      x1="28"
      y1="24"
      x2="44"
      y2="24"
      stroke="currentColor"
      strokeWidth="5"
      strokeLinecap="round"
      strokeDasharray="16"
      className="motion-safe:animate-draw-row"
      style={{ animationDelay: `${ROW_AT}ms` }}
    />
  </svg>
)
